// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".slot_title[data-v-8382c754]{font-size:20px;color:#333;letter-spacing:0;font-weight:700;margin-bottom:20px}", ""]);
// Exports
module.exports = exports;
